
export const AppName = ({
  name,
  logo
}: {
  name?: string
  logo?: string
}) => (
  <div className="flex flex-row items-center">
    <img src={logo || ''} className="h-[32px] mr-4" />
    <h3 className="font-semibold leading-7 text-xl text-primary">{name || ''}</h3>
  </div>
)
